export const BASE_URL = '/api/v1';

export const USER_ROLE_PATH = `${BASE_URL}/user/roles`;
export const PASSWORD_RESET_PATH = `${BASE_URL}/user/roles/password-reset`;
export const OPERATION_LOGS_PATH = `${BASE_URL}/operation-logs`;

export const LINES_PATH = `${BASE_URL}/lines`;
export const TRAINS_PATH = `${BASE_URL}/trains`;
export const SEATS_PATH = `${BASE_URL}/seats/by-train`;
export const STATIONS_PATH = `${BASE_URL}/stations`;
export const TRAIN_DIRECTIONS_PATH = `${BASE_URL}/directions`;

export const SEAT_CLASS_TYPES_PATH = `${BASE_URL}/seat-class-types`;
export const SEAT_CLASS_DETAILS_TRAIN_PATH = `${BASE_URL}/train-seat-classes/by-train`;
export const SEAT_CLASS_DETAILS_PATH = `${BASE_URL}/seat-class-details/by-train`;
export const SEAT_ADJUSTMENT_TYPES_PATH = `${BASE_URL}/seat-adjustment-types`;
export const SEAT_ADJUSTMENTS_PATH = `${BASE_URL}/seat-adjustments/by-train`;
export const SEAT_ADJUSTMENT_PATH = `${BASE_URL}/seat-adjustments`;

export const STATION_STOP_PATTERNS_LINE_PATH = `${BASE_URL}/station-stop-patterns/line`;
export const STATION_STOP_PATTERNS_PATH = `${BASE_URL}/station-stop-patterns`;

export const TRAIN_SCHEDULE_LINE_PATH = `${BASE_URL}/train-schedule/line`;
export const TRAIN_SCHEDULE_PATH = `${BASE_URL}/train-schedule`;
export const TRAIN_SERVICES_PATH = `${BASE_URL}/train-services`;

export const TRAIN_ASSIGNMENTS_PATH = `${BASE_URL}/train-assignments`;

export const SUSPENSIONS_PATH = `${BASE_URL}/suspensions`;

export const WORKFLOWS_PATH = `${BASE_URL}/workflows`;

export const CALENDAR_PATH = `${BASE_URL}/calendar`;

export const INVENTORY_TRAINS_PATH = `${BASE_URL}/inventory/trains`;
export const INVENTORY_SEATS_PATH = `${BASE_URL}/inventory/seats`;
export const INVENTORY_SEATS_WITH_SUSPENSION_INFO_PATH = `${BASE_URL}/inventory/seats-with-suspension-info`;
export const INVENTORY_RESERVED_TRAINS_PATH = `${BASE_URL}/inventory/reserved-trains`;

export const SPECIAL_SEAT_ADJUSTMENT_PATH = `${BASE_URL}/special-seat-adjustments`;

export const ORDERS_PATH = `${BASE_URL}/orders`;

export const TIMETABLE_PATH = `${BASE_URL}/timetable`;

export const SEAT_ORDER_HISTORY_PATH = `${BASE_URL}/seat-order-history`;
